import Controller from "./autocomplete.controller";
import template from "./autocomplete.html";

const autocomplete = {
  template,
  controller: Controller,
  bindings: {
    resource: "<",
    isRequired: "<",
    selected: "=",
    name: "<",
    title: "<",
    onSelect: "@",
    onSelectEvent: "=",
    customStyle: "@",
    params: "<",
    extraParams: "<",
    showRemove: "<",
    ngDisabled: "<?",
  },
};

export default autocomplete;



// WEBPACK FOOTER //
// ./src/components/autocomplete/autocomplete.component.js